import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { workspaceQueryKey } from '../providers/WorkspaceInfo/hooks/common';

export function useWorkspaceInfoRefetch() {
  const queryClient = useQueryClient();

  const refetchWorkspaceInfo = useCallback(() => {
    queryClient.invalidateQueries(workspaceQueryKey);
  }, [queryClient]);

  return { refetchWorkspaceInfo };
}
